module.exports = __webpack_public_path__ + "static/media/checkpreparation.9188d5df.png";